import { render, staticRenderFns } from "./ValidationsRequestContentTable.vue?vue&type=template&id=690d34ae"
import script from "./ValidationsRequestContentTable.vue?vue&type=script&lang=js"
export * from "./ValidationsRequestContentTable.vue?vue&type=script&lang=js"
import style0 from "./ValidationsRequestContentTable.vue?vue&type=style&index=0&id=690d34ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports